import React, { Component } from 'react'
import { Col, Form, InputNumber, Row } from 'antd'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import AccountsCascader from '../../../../../elements/Cascader/AccountsCascader'

class BookingForm extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    const { budgetLine } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18, offset: 1 },
      },
    }
    return (
      <Row>
        <Form layout={'horizontal'}>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Target'}>
              {getFieldDecorator('target', {
                initialValue: get(budgetLine, 'target'),
                rules: [{ required: true, message: "Title can't be empty" }],
              })(<InputNumber style={{ width: '100%' }} placeholder={'Target'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Account'}>
              {getFieldDecorator('account._id', {
                initialValue: get(budgetLine, 'account._id'),
                rules: [{ required: true, message: "Title can't be empty" }],
              })(
                <AccountsCascader
                  center={get(budgetLine, 'center._id')}
                  placeholder={'Account'}
                  codeMin={5000}
                />,
              )}
            </Form.Item>
          </Col>
        </Form>
      </Row>
    )
  }
}

BookingForm.propTypes = {}
BookingForm.defaultProps = { booking: {}, type: 'new' }

export default compose(Form.create())(BookingForm)
